import React,{useState, useEffect} from 'react';
import calenderIcon from '../../../assets/img/event-imgs/calendar.svg';
import userIcon from '../../../assets/img/group-imgs/group-pic1.png';
import  ePlusIcon  from '../../../assets/img/event-imgs/e-plus.svg';
import {showAllEventsData as showAllEventsDataApi } from '../../../api'
import { Link } from 'react-router-dom';
const ShowAllEvents = () => {
    const [  showAllEventsDatas, setShowAllEventsDatas ] = useState([])
    
    useEffect( ()=>{
        showAllEventsDataApi().then( data => setShowAllEventsDatas(data))
    },[])

    console.log( "parent Events", showAllEventsDatas)
    return (
        <div className="row g-4 mt-lg-0 mt-2">
            {
                showAllEventsDatas.map(( item, index ) =><div className="col-12 col-md-6 col-xxl-4" key={index}>
                <Link className="card " style={{backgroundColor: "#171717", borderRadius: "20px",borderStyle: "none", textDecoration: "none"}} to={`/events/details/${index}`}>
                    <div className="position-relative">
                        <button className="btn btn-primary position-absolute rounded-circle d-flex justify-content-center align-items-center p-1" type="button" style={{backgroundColor: "#00000041", borderStyle: "none", right: "4%", bottom: "4%"}}>
                            <img src={ePlusIcon} alt='' />
                        </button>
                        <img className="w-100 event-image-design " src={userIcon} alt='' />
                    </div>
                    <div className="card-body">
                        <div className="row gap-2">
                            <div className="col-12">
                                <img className="me-1" src={calenderIcon} alt='' />
                                    <span className="e_bdt">{item.eventData}</span>
                            </div>
                            <div className="col-12">
                                <span className="grp_h">{item.eventTitle}&nbsp;</span>
                            </div>
                            <div className="col-12">
                                <span className="e_bdt">{item.interestedPeople} Interested</span>
                                <span className="e_bdt">&nbsp;·&nbsp;</span>
                                <span className="e_bdt">{item.goingPeople} Going</span>
                            </div>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12">
                                        <button className="custm-pill-button-small p-0 g_joinbtn rounded-pill w-100" type="button">Interested</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>)
            }
        </div>
    );
};

export default ShowAllEvents;